export interface Scenario {
  id: string,
  type: string,
  customizable: boolean,
  name?: string
  homeId: string,
  modulesId?: string[],
}

export interface ModuleScenario {
  id: string,
  bridge: string,
  scenarios: Array< {id: string, target_position?: number}>
}

export interface HomeScenario {
  id: string,
  scenarios: Scenarios,
  modules?: ModuleScenario[]
}

export enum DefaultScenario {
  WAKE_UP = 'wake_up',
  BEDTIME = 'bedtime',
  HOME = 'home',
  AWAY = 'away',
  PARTY = 'party',
  MUSIC = 'music',
  TV = 'tv',
  WORK = 'work',
  RELAXATION = 'relaxation',
  READING = 'reading',
  SPORT = 'sport',
  ROMANTIC = 'romantic',
  HOLIDAYS = 'holidays',
  GARAGE = 'garage',
  SWIMMING_POOL = 'swimming_pool',
}

export const scenarioIcons = new Map([
  [DefaultScenario.WAKE_UP, 'wake-up'],
  [DefaultScenario.BEDTIME, 'sleep'],
  [DefaultScenario.HOME, 'at-home-32'],
  [DefaultScenario.AWAY, 'away-32'],
  [DefaultScenario.PARTY, 'party'],
  [DefaultScenario.MUSIC, 'music'],
  [DefaultScenario.TV, 'tv'],
  [DefaultScenario.WORK, 'work'],
  [DefaultScenario.RELAXATION, 'relax'],
  [DefaultScenario.READING, 'reading'],
  [DefaultScenario.SPORT, 'sport'],
  [DefaultScenario.ROMANTIC, 'love'],
  [DefaultScenario.HOLIDAYS, 'holidays'],
  [DefaultScenario.GARAGE, 'garage'],
  [DefaultScenario.SWIMMING_POOL, 'pool'],
]);

export type Scenarios = Scenario[];

